/**
 * @flow
 * @relayHash a871a86868170c3da90cb9254e80cfec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePipelineInput = {
  clientMutationId?: ?string,
  user_id: string,
  title: string,
};
export type PipelinesComponent_createPipelineMutationVariables = {|
  input: CreatePipelineInput
|};
export type PipelinesComponent_createPipelineMutationResponse = {|
  +createPipeline: ?{|
    +new_pipeline_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +plists: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +position: ?number,
              +plist_events: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string
                  |}
                |}>
              |},
            |}
          |}>
        |},
      |}
    |}
  |}
|};
export type PipelinesComponent_createPipelineMutation = {|
  variables: PipelinesComponent_createPipelineMutationVariables,
  response: PipelinesComponent_createPipelineMutationResponse,
|};
*/


/*
mutation PipelinesComponent_createPipelineMutation(
  $input: CreatePipelineInput!
) {
  createPipeline(input: $input) {
    new_pipeline_edge {
      node {
        id
        title
        plists(first: 99999) {
          edges {
            node {
              id
              title
              position
              plist_events(first: 99999) {
                edges {
                  node {
                    id
                    __typename
                  }
                  cursor
                }
                pageInfo {
                  endCursor
                  hasNextPage
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePipelineInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePipelineInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEventEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "PlistEvent",
        "plural": false,
        "selections": [
          v2,
          v5
        ]
      },
      v6
    ]
  },
  v7
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PipelinesComponent_createPipelineMutation",
  "id": null,
  "text": "mutation PipelinesComponent_createPipelineMutation(\n  $input: CreatePipelineInput!\n) {\n  createPipeline(input: $input) {\n    new_pipeline_edge {\n      node {\n        id\n        title\n        plists(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              position\n              plist_events(first: 99999) {\n                edges {\n                  node {\n                    id\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": null
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "createPipeline",
          "new_pipeline_edge",
          "node",
          "plists"
        ]
      }
    ]
  },
  "fragment": {
    "kind": "Fragment",
    "name": "PipelinesComponent_createPipelineMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPipeline",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePipelinePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_pipeline_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PipelineEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Pipeline",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": "plists",
                    "name": "__PipelinesContainer_plists_connection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlistConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlistEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Plist",
                            "plural": false,
                            "selections": [
                              v2,
                              v3,
                              v4,
                              {
                                "kind": "LinkedField",
                                "alias": "plist_events",
                                "name": "__PipelinesContainer_plist_events_connection",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PlistEventConnection",
                                "plural": false,
                                "selections": v8
                              },
                              v5
                            ]
                          },
                          v6
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PipelinesComponent_createPipelineMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPipeline",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePipelinePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_pipeline_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PipelineEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Pipeline",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "plists",
                    "storageKey": "plists(first:99999)",
                    "args": v9,
                    "concreteType": "PlistConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlistEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Plist",
                            "plural": false,
                            "selections": [
                              v2,
                              v3,
                              v4,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "plist_events",
                                "storageKey": "plist_events(first:99999)",
                                "args": v9,
                                "concreteType": "PlistEventConnection",
                                "plural": false,
                                "selections": v8
                              },
                              {
                                "kind": "LinkedHandle",
                                "alias": null,
                                "name": "plist_events",
                                "args": v9,
                                "handle": "connection",
                                "key": "PipelinesContainer_plist_events",
                                "filters": null
                              },
                              v5
                            ]
                          },
                          v6
                        ]
                      },
                      v7
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "plists",
                    "args": v9,
                    "handle": "connection",
                    "key": "PipelinesContainer_plists",
                    "filters": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa72a027efffbcf4a89f4adb24f56cf9';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/__generated__/PipelinesComponent_createPipelineMutation.graphql.js